<template>
  <el-row :gutter="15">
    <el-col :md="10">
      <el-card
        header="Key Fields"
        shadow="never"
      >
        <el-row type="flex">
          <el-col :md="11">
            <p>
              <b>Contact: </b>
              <span>{{ $_.get(account, 'contact', '-') || '-' }}</span>
            </p>
            <p>
              <b>Address: </b>
              <span>{{ $_.get(account, 'address', '-') + " " + $_.get(account, 'suburb', '-') + " " + $_.get(account, 'state', '-') + " " + $_.get(account, 'postcode', '-') }}</span>
            </p>
            <p>
              <b>Phone: </b>
              <a
                v-if="$_.get(account, 'phone')"
                :href="`tel:${$_.get(account, 'phone', '-')}`"
              >{{ $_.get(account, 'phone', '-') }}</a>
              <span v-else>-</span>
            </p>
            <p>
              <b>Email: </b>
              <a
                v-if="$_.get(account, 'email')"
                :href="`mailto:${$_.get(account, 'email', '-')}`"
              >{{ $_.get(account, 'email', '-') }}</a>
              <span v-else>-</span>
            </p>
            <p>
              <b>Fax: </b>
              <span>{{ $_.get(account, 'fax', '-') }}</span>
            </p>
            <p>
              <b>Billing Code: </b>
              <span>{{ $_.get(account, 'reference', '-') }}</span>
            </p>
            <p>
              <b>Parent Account: </b>
              <span>{{ $_.get(account, 'parent.name', '-') }}</span>
            </p>
            <p>
              <b>ABN: </b>
              <span>{{ $_.get(account, 'billing_abn', '-') }}</span>
            </p>
            <p>
              <b>Account Grade: </b>
              <span>
                <el-tag
                  :type="getGradeTagType($_.get(account, 'crm_account_grade'))"
                  size="mini"
                >
                  {{ getGradeDescription($_.get(account, 'crm_account_grade')) }}
                </el-tag>
              </span>
            </p>
          </el-col>
          <el-col :md="2">
            <div class="divider-container">
              <div class="divider" />
            </div>
          </el-col>
          <el-col :md="11">
            <p>
              <b>Account Manager: </b>
              <span>{{ $_.get(account, 'portfolio.profile.name_full', '-') }}</span>
            </p>
            <p>
              <b>Phone (Primary): </b>
              <a
                v-if="$_.get(account, 'portfolio.profile.phone_primary')"
                :href="`tel:${$_.get(account, 'portfolio.profile.phone_primary', '-')}`"
              >{{ $_.get(account, 'portfolio.profile.phone_primary', '-') }}</a>
              <span v-else>-</span>
            </p>
            <p>
              <b>Phone (Secondary): </b>
              <a
                v-if="$_.get(account, 'portfolio.profile.phone_secondary')"
                :href="`tel:${$_.get(account, 'portfolio.profile.phone_secondary', '-')}`"
              >{{ $_.get(account, 'portfolio.profile.phone_secondary', '-') }}</a>
              <span v-else>-</span>
            </p>
            <p>
              <b>Email: </b>
              <a
                v-if="$_.get(account, 'portfolio.profile.email')"
                :href="`mailto:${$_.get(account, 'portfolio.profile.email', '-')}`"
              >{{ $_.get(account, 'portfolio.profile.email', '-') }}</a>
              <span v-else>-</span>
            </p>
            <p>
              <b>Business Group: </b>
              <span>{{ $_.get(account, 'b_group.long', '-') }}</span>
            </p>
          </el-col>
        </el-row>
      </el-card>
    </el-col>
    <el-col :md="14">
      <el-card shadow="never">
        <div slot="header">
          <span>Notes</span>
          <el-button
            type="text"
            @click.native="$refs.notes.create()"
          >
            Add Note
          </el-button>
        </div>
        <Notes
          ref="notes"
          :resource="account"
          truncate
          paginate
          pagination-layout="prev, pager, next"
          :limit="3"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Notes from '@/components/Notes'
export default {
  components: {
    Notes
  },
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  methods: {
    getStatusTagType (status) {
      switch (status) {
        case 'on hold':
          return 'danger'
        default:
          return 'info'
      }
    },
    getGradeTagType (grade) {
      switch (grade) {
        case 1:
        case 6:
          return 'success'
        case 2:
        case 3:
          return 'warning'
        case 4:
          return 'danger'
        case 5:
        default:
          return 'info'
      }
    },
    getGradeDescription (grade) {
      switch (grade) {
        case 1:
          return 'A'
        case 2:
          return 'B'
        case 3:
          return 'C'
        case 4:
          return 'D'
        case 6:
          return 'HC'
        case 5:
        default:
          return 'No Trade'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.divider-container {
  display: flex;
  justify-content: center;
  height: 100%;
  .divider {
    background-color: #eeeeee;
    height: 100%;
    width: 1px;
  }
}
</style>
